// modules
import { createAction } from 'redux-actions'

export const setActivitiesList = createAction('SET_ACTIVITIES_LIST')
export const setActivitiesStatistics = createAction('SET_ACTIVITIES_STATISTICS')

export const deleteActivities = createAction('DELETE_ACTIVITIES')
